import React, {Component} from 'react';
import CommissionSensor from '../Report/CommissionSensor'
import ChartModal from './ChartModal'

export default class CommissionChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirecting: false,
    }
    this.redirecting = this.redirecting.bind(this)
  }
  componentDidMount() {
    this.props.breadCrumb([{display:'Uncommissioned', click:this.redirecting}, 
    {display: this.props.chartProps.radioId, click:undefined}])
  }
  redirecting(){
    this.setState({redirecting: true});
  }
  render() {
    if (this.state.redirecting) 
      return (<CommissionSensor {...this.props} />);

    return (<ChartModal {...this.props} />)
  }
}